import React from 'react';
import BaseModel from './BaseModel';
import ReactTimeAgo from 'react-time-ago';
import i18n from '../locales/i18n';
import moment from 'moment';

/** Class representing a generic device. */
class Device extends BaseModel {
    static TYPE_HOST       = 'host';
    static TYPE_PRINTER    = 'printer';
    static TYPE_EFT        = 'eft';
    static TYPE_COLLECTOR  = 'collector';
    static TYPE_CASHDRAWER = 'cashdrawer';

    constructor(properties) {
        super(properties);

        if (this.last_connexion)
            this.last_connexion = moment(this.last_connexion);
    }

    isConnected() {
        return this.status === 'connected';
    }

    wasRecentlyConnected() {
        return moment().subtract(7, 'days').isBefore(this.last_connexion);
    }

    getLastConnectedAt() {
        return (
            <ReactTimeAgo
                date={ this.last_connexion.toDate() }
                locale={ i18n.language }
                timeStyle="round-minute"
            />
        );
    }

    getHostInfos() {
        return {
            _id: this.host_id,
            name: this.host
        };
    }

    getIconName() {
        return 'cube';
    }
}

export default Device;
